import React from 'react';
import { useCookies } from 'react-cookie';

const ExampleComponent = () => {
  const [cookies, setCookie] = useCookies();

  const email = 'examplejdjdexample.com'; // Replace with the actual email value

  setCookie('email', email);

  return (
    <div>
      {/* Your component content */}
      coockiees
    </div>
  );
};

export default ExampleComponent;